import { COUPON_TYPES, MENU_TYPES } from '../constants.js';
import { BaseMenuEntityConfiguration } from '../entityConfigs/index.js';
const getDefaultCouponType = () => 'ticket-percent';
const getDefaultMenuType = () => 'olo';
export default new BaseMenuEntityConfiguration({
    consumable: false,
    filters: [
        {
            name: 'type',
            options: COUPON_TYPES,
            type: 'Select',
        },
        {
            name: 'campaign',
            type: 'String',
        },
        {
            name: 'promotional',
            type: 'Boolean',
        },
        {
            name: 'internal',
            type: 'Boolean',
        },
        {
            name: 'menuType',
            options: MENU_TYPES,
            type: 'Select',
        },
    ],
    hasDescription: true,
    hasHours: true,
    hasImage: false,
    hasVariations: false,
    hasPos: false,
    hasPresentation: false,
    lists: [
        {
            collection: 'Category',
            name: 'redeemableCategories',
        },
        {
            collection: 'Item',
            name: 'redeemableItems',
        },
        {
            collection: 'Category',
            name: 'purchaseableCategories',
        },
        {
            collection: 'Item',
            name: 'purchaseableItems',
        },
        {
            collection: 'Category',
            name: 'excludedCategories',
        },
        {
            collection: 'Item',
            name: 'excludedItems',
        },
    ],
    name: 'Coupon',
    options: {
        amount: 0,
        campaign: null,
        code: '',
        end: null,
        maxQuantity: null,
        min: 0,
        maxDiscountAmount: null,
        maxItemAmountCents: null,
        itemSelectionCriteria: null,
        fixedPrice: null,
        maxItemsRedeemable: null,
        maxApplyTimes: null,
        promotional: false,
        firstTimeOnly: null,
        resetPeriod: null,
        start: null,
        type: getDefaultCouponType(),
        redeemableChannels: [],
        redeemableOrderTypes: [],
        internal: false,
        menuType: getDefaultMenuType(),
    },
    pluralizedName: 'Coupons',
    sellable: false,
    sortKeys: ['amount'],
    unlinkedOptions: [],
    version: 11,
});
//# sourceMappingURL=coupon.js.map